import script from "./LogPresenter.vue?vue&type=script&lang=js"
export * from "./LogPresenter.vue?vue&type=script&lang=js"

import "./LogPresenter.vue?vue&type=style&index=0&id=ee795a30&scoped=true&lang=scss"

import exportComponent from "D:\\DongLK\\Project\\ytbot\\controller-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee795a30"]])

export default __exports__